import { render, staticRenderFns } from "./GlobalCode.vue?vue&type=template&id=60dad6a6"
import script from "./GlobalCode.vue?vue&type=script&lang=js"
export * from "./GlobalCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports